// Generated by purs version 0.15.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Parallel from "../Control.Parallel/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Random from "../Effect.Random/index.js";
import * as PartyCarlo_Data_Probability from "../PartyCarlo.Data.Probability/index.js";
import * as PartyCarlo_Data_SortedArray from "../PartyCarlo.Data.SortedArray/index.js";
import * as PartyCarlo_Utils from "../PartyCarlo.Utils/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var map = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var lessThan = /* #__PURE__ */ Data_Ord.lessThan(PartyCarlo_Data_Probability.ordProbability);
var parSequence = /* #__PURE__ */ Control_Parallel.parSequence(Effect_Aff.parallelAff)(Data_Traversable.traversableArray);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var replicateM = /* #__PURE__ */ PartyCarlo_Utils.replicateM(Effect.applicativeEffect);
var apply = /* #__PURE__ */ Control_Apply.apply(Data_Maybe.applyMaybe);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var fromArray = /* #__PURE__ */ PartyCarlo_Data_SortedArray.fromArray(Data_Ord.ordInt);
var $lazy_rand = /* #__PURE__ */ $runtime_lazy("rand", "PartyCarlo.MonteCarlo", function () {
    return Control_Bind.bindFlipped(Effect.bindEffect)((function () {
        var $25 = Data_Either.either(function (v) {
            return $lazy_rand(50);
        })(pure);
        return function ($26) {
            return $25(PartyCarlo_Data_Probability.mkProbability($26));
        };
    })())(Effect_Random.random);
});
var rand = /* #__PURE__ */ $lazy_rand(49);
var oneSample = /* #__PURE__ */ Data_Foldable.foldM(Data_Foldable.foldableArray)(Effect.monadEffect)(function (count) {
    return function (d) {
        return map(function (p) {
            return PartyCarlo_Utils["if$prime"](lessThan(p)(d))(count + 1 | 0)(count);
        })(rand);
    };
})(0);
var parSample = function (count) {
    return function (dist) {
        return parSequence(Data_Array.replicate(count)(liftEffect(oneSample(dist))));
    };
};
var sample = function (count) {
    return function (dist) {
        return replicateM(count)(oneSample(dist));
    };
};
var confidenceInterval = function (dictOrd) {
    return function (p) {
        return function (v) {
            if (PartyCarlo_Data_Probability.toNumber(p) <= 0.5) {
                return Data_Maybe.Nothing.value;
            };
            var len = PartyCarlo_Data_SortedArray.length(v);
            var low = PartyCarlo_Data_SortedArray.index(v)(Data_Int.floor((1.0 - PartyCarlo_Data_Probability.toNumber(p)) * Data_Int.toNumber(len)));
            var high = PartyCarlo_Data_SortedArray.index(v)(Data_Int.floor(PartyCarlo_Data_Probability.toNumber(p) * Data_Int.toNumber(len)));
            return apply(map1(Data_Tuple.Tuple.create)(low))(high);
        };
    };
};
var confidenceInterval1 = /* #__PURE__ */ confidenceInterval(Data_Ord.ordInt);
var monteCarloConfidenceInterval = function (p) {
    return function (count) {
        return function (dist) {
            return function __do() {
                var samples = sample(count)(dist)();
                return confidenceInterval1(p)(fromArray(samples));
            };
        };
    };
};
export {
    monteCarloConfidenceInterval,
    confidenceInterval,
    parSample,
    sample,
    oneSample,
    rand
};
